import type { Task } from '../../types';

export interface TaskBuckets {
  myActive: Task[];
  awaitingReview: Task[];
  myReviews: Task[];
  changesRequested: Task[];
  submitted: Task[];
  approvedInCampaign: Task[];
}

export interface BucketizeInput {
  myOpenTasks: Task[];
  myReviews: Task[];
  awaitingReview: Task[];
  myApproved: Task[];
  approvedInCampaign: Task[];
  selectedCampaignId: string;
  uid: string;
  filterOwnerId?: string | null;
}

/** Pure router from repository streams to the queue presentation buckets. */
export function bucketizeQueue(input: BucketizeInput): TaskBuckets {
  const {
    myOpenTasks,
    myReviews,
    awaitingReview,
    myApproved,
    approvedInCampaign,
    selectedCampaignId,
    uid,
    filterOwnerId,
  } = input;
  const inSelectedCampaign = (task: Task) => task.campaignId === selectedCampaignId;
  const matchesOwnerFilter = (task: Task) => !filterOwnerId || task.ownerId === filterOwnerId;
  const ownedHere = myOpenTasks.filter((task) => task.ownerId === uid && inSelectedCampaign(task));
  const ownedApprovedHere = myApproved.filter(
    (task) => task.ownerId === uid && task.status === 'approved' && inSelectedCampaign(task),
  );
  const ownedInReviewHere = ownedHere.filter((task) => task.status === 'in_review');

  return {
    myActive: ownedHere
      .filter((task) => task.status === 'claimed' || task.status === 'in_progress')
      .filter(matchesOwnerFilter),
    changesRequested: ownedHere
      .filter((task) => task.status === 'changes_requested')
      .filter(matchesOwnerFilter),
    myReviews: myReviews
      .filter((task) => task.reviewerId === uid && task.status === 'in_review' && inSelectedCampaign(task))
      .filter(matchesOwnerFilter),
    awaitingReview: awaitingReview
      .filter((task) => task.status === 'in_review' && task.reviewerId === null)
      .filter(matchesOwnerFilter),
    submitted: [...ownedInReviewHere, ...ownedApprovedHere]
      .filter(matchesOwnerFilter)
      .sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime()),
    approvedInCampaign: approvedInCampaign.filter(matchesOwnerFilter),
  };
}
